/**
 * @fileOverview In-memory store for the post-login encryption session.
 * The key never touches localStorage / sessionStorage / cookies.
 * @module encryption/sessionStore
 */

import { SESSION_EXPIRY_SKEW_MS } from "./config";

let session = null;

export const clearSession = () => {
  session = null;
};

export const saveSession = (value) => {
  session = value;
};

/**
 * Returns the usable session for this login, or null. A session that belongs
 * to another login / account, or is about to expire, is discarded.
 */
export const getSession = (owner) => {
  if (!session) return null;
  if (session.owner !== owner) {
    session = null;
    return null;
  }
  if (session.expiresAt - SESSION_EXPIRY_SKEW_MS <= Date.now()) {
    session = null;
    return null;
  }
  return session;
};
